module.exports = "/img/21.4d2995.webp";